module.exports = __webpack_public_path__ + "static/img/download@w.db89c04.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/project-detail/lg-chem-pr-portal/download@w.jpg
// module id = 6qa6
// module chunks = 0